// Templates de variables pré-définies organisés par catégories
export const VARIABLE_TEMPLATES = {
  // ========================
  // VARIABLES OBJET
  // ========================

  personne_physique_simple: {
    name: 'Personne physique simple',
    description: 'Variable objet composée de 4 éléments : civilité / prénom / nom / adresse',
    category: 'object',
    type: 'object',
    options: [
      { id: 'civilite', label: 'Civilité', type: 'choice' },
      { id: 'prenom', label: 'Prénom', type: 'text' },
      { id: 'nom', label: 'Nom', type: 'text' },
      { id: 'adresse', label: 'Adresse', type: 'text' },
    ],
    placeholder: [
      { id: 'civilite', value: 'M.' },
      { id: 'prenom', value: '' },
      { id: 'nom', value: '' },
      { id: 'adresse', value: '' },
    ],
  },

  personne_physique_complet: {
    name: 'Personne physique complet',
    description:
      'Variable objet composée de 6 éléments : civilité / prénom / nom / adresse / date de naissance / lieu de naissance',
    category: 'object',
    type: 'object',
    options: [
      { id: 'civilite', label: 'Civilité', type: 'choice' },
      { id: 'prenom', label: 'Prénom', type: 'text' },
      { id: 'nom', label: 'Nom', type: 'text' },
      { id: 'adresse', label: 'Adresse', type: 'text' },
      { id: 'date_naissance', label: 'Date de naissance', type: 'date' },
      { id: 'lieu_naissance', label: 'Lieu de naissance', type: 'text' },
    ],
    placeholder: [
      { id: 'civilite', value: 'M.' },
      { id: 'prenom', value: '' },
      { id: 'nom', value: '' },
      { id: 'adresse', value: '' },
      { id: 'date_naissance', value: '' },
      { id: 'lieu_naissance', value: '' },
    ],
  },

  personne_morale_complet: {
    name: 'Personne morale complet',
    description:
      "Variable objet composée de 8 éléments : dénomination sociale / forme sociale / capital social / adresse du siège social / ville d'immatriculation / numéro de SIREN / identité du représentant légal / fonctions du représentant légal",
    category: 'object',
    type: 'object',
    options: [
      { id: 'denomination_sociale', label: 'Dénomination sociale', type: 'text' },
      { id: 'forme_sociale', label: 'Forme sociale', type: 'text' },
      { id: 'capital_social', label: 'Capital social', type: 'number' },
      { id: 'adresse_siege_social', label: 'Adresse du siège social', type: 'text' },
      { id: 'ville_immatriculation', label: "Ville d'immatriculation", type: 'text' },
      { id: 'numero_siren', label: 'Numéro de SIREN', type: 'text' },
      { id: 'identite_representant_legal', label: 'Identité du représentant légal', type: 'text' },
      {
        id: 'fonctions_representant_legal',
        label: 'Fonctions du représentant légal',
        type: 'text',
      },
    ],
    placeholder: [
      { id: 'denomination_sociale', value: '' },
      { id: 'forme_sociale', value: '' },
      { id: 'capital_social', value: 0 },
      { id: 'adresse_siege_social', value: '' },
      { id: 'ville_immatriculation', value: '' },
      { id: 'numero_siren', value: '' },
      { id: 'identite_representant_legal', value: '' },
      { id: 'fonctions_representant_legal', value: '' },
    ],
  },

  personne_morale_simple: {
    name: 'Personne morale simple',
    description:
      "Variable objet composée de 7 éléments : dénomination sociale / forme sociale / capital social / adresse du siège social / ville d'immatriculation / numéro de SIREN / représentant légal / fonctions du représentant légal",
    category: 'object',
    type: 'object',
    options: [
      { id: 'denomination_sociale', label: 'Dénomination sociale', type: 'text' },
      { id: 'forme_sociale', label: 'Forme sociale', type: 'text' },
      { id: 'capital_social', label: 'Capital social', type: 'number' },
      { id: 'adresse_siege_social', label: 'Adresse du siège social', type: 'text' },
      { id: 'ville_immatriculation', label: "Ville d'immatriculation", type: 'text' },
      { id: 'numero_siren', label: 'Numéro de SIREN', type: 'text' },
      { id: 'representant_legal', label: 'Représentant légal', type: 'text' },
      {
        id: 'fonctions_representant_legal',
        label: 'Fonctions du représentant légal',
        type: 'text',
      },
    ],
    placeholder: [
      { id: 'denomination_sociale', value: '' },
      { id: 'forme_sociale', value: '' },
      { id: 'capital_social', value: 0 },
      { id: 'adresse_siege_social', value: '' },
      { id: 'ville_immatriculation', value: '' },
      { id: 'numero_siren', value: '' },
      { id: 'representant_legal', value: '' },
      { id: 'fonctions_representant_legal', value: '' },
    ],
  },

  associe_pp_parts: {
    name: 'Associé PP - parts',
    description:
      'Variable objet composée de 4 éléments : civilité / prénom / nom / nombre de parts',
    category: 'object',
    type: 'object',
    options: [
      { id: 'civilite', label: 'Civilité', type: 'choice' },
      { id: 'prenom', label: 'Prénom', type: 'text' },
      { id: 'nom', label: 'Nom', type: 'text' },
      { id: 'nombre_parts', label: 'Nombre de parts', type: 'number' },
    ],
    placeholder: [
      { id: 'civilite', value: 'M.' },
      { id: 'prenom', value: '' },
      { id: 'nom', value: '' },
      { id: 'nombre_parts', value: 0 },
    ],
  },

  associe_pp_actions: {
    name: 'Associé PP - actions',
    description:
      "Variable objet composée de 4 éléments : civilité / prénom / nom / nombre d'actions",
    category: 'object',
    type: 'object',
    options: [
      { id: 'civilite', label: 'Civilité', type: 'choice' },
      { id: 'prenom', label: 'Prénom', type: 'text' },
      { id: 'nom', label: 'Nom', type: 'text' },
      { id: 'nombre_actions', label: "Nombre d'actions", type: 'number' },
    ],
    placeholder: [
      { id: 'civilite', value: 'M.' },
      { id: 'prenom', value: '' },
      { id: 'nom', value: '' },
      { id: 'nombre_actions', value: 0 },
    ],
  },

  associe_pm_parts: {
    name: 'Associé PM - parts',
    description:
      "Variable objet composée de 8 éléments : dénomination sociale / forme sociale / capital social / adresse du siège social / ville d'immatriculation / numéro de SIREN / identité du représentant légal / nombre de parts",
    category: 'object',
    type: 'object',
    options: [
      { id: 'denomination_sociale', label: 'Dénomination sociale', type: 'text' },
      { id: 'forme_sociale', label: 'Forme sociale', type: 'text' },
      { id: 'capital_social', label: 'Capital social', type: 'number' },
      { id: 'adresse_siege_social', label: 'Adresse du siège social', type: 'text' },
      { id: 'ville_immatriculation', label: "Ville d'immatriculation", type: 'text' },
      { id: 'numero_siren', label: 'Numéro de SIREN', type: 'text' },
      { id: 'identite_representant_legal', label: 'Identité du représentant légal', type: 'text' },
      { id: 'nombre_parts', label: 'Nombre de parts', type: 'number' },
    ],
    placeholder: [
      { id: 'denomination_sociale', value: '' },
      { id: 'forme_sociale', value: '' },
      { id: 'capital_social', value: 0 },
      { id: 'adresse_siege_social', value: '' },
      { id: 'ville_immatriculation', value: '' },
      { id: 'numero_siren', value: '' },
      { id: 'identite_representant_legal', value: '' },
      { id: 'nombre_parts', value: 0 },
    ],
  },

  associe_pm_actions: {
    name: 'Associé PM - actions',
    description:
      "Variable objet composée de 8 éléments : dénomination sociale / forme sociale / capital social / adresse du siège social / ville d'immatriculation / numéro de SIREN / identité du représentant légal / nombre d'actions",
    category: 'object',
    type: 'object',
    options: [
      { id: 'denomination_sociale', label: 'Dénomination sociale', type: 'text' },
      { id: 'forme_sociale', label: 'Forme sociale', type: 'text' },
      { id: 'capital_social', label: 'Capital social', type: 'number' },
      { id: 'adresse_siege_social', label: 'Adresse du siège social', type: 'text' },
      { id: 'ville_immatriculation', label: "Ville d'immatriculation", type: 'text' },
      { id: 'numero_siren', label: 'Numéro de SIREN', type: 'text' },
      { id: 'identite_representant_legal', label: 'Identité du représentant légal', type: 'text' },
      { id: 'nombre_actions', label: "Nombre d'actions", type: 'number' },
    ],
    placeholder: [
      { id: 'denomination_sociale', value: '' },
      { id: 'forme_sociale', value: '' },
      { id: 'capital_social', value: 0 },
      { id: 'adresse_siege_social', value: '' },
      { id: 'ville_immatriculation', value: '' },
      { id: 'numero_siren', value: '' },
      { id: 'identite_representant_legal', value: '' },
      { id: 'nombre_actions', value: 0 },
    ],
  },

  employe: {
    name: 'Employé',
    description:
      "Variable objet composée de 11 éléments : civilité / prénom / nom / adresse / date de naissance / lieu de naissance / numéro de sécurité sociale / emploi / niveau hiérarchique / convention collective applicable / date d'entrée dans l'entreprise",
    category: 'object',
    type: 'object',
    options: [
      { id: 'civilite', label: 'Civilité', type: 'choice' },
      { id: 'prenom', label: 'Prénom', type: 'text' },
      { id: 'nom', label: 'Nom', type: 'text' },
      { id: 'adresse', label: 'Adresse', type: 'text' },
      { id: 'date_naissance', label: 'Date de naissance', type: 'date' },
      { id: 'lieu_naissance', label: 'Lieu de naissance', type: 'text' },
      { id: 'numero_securite_sociale', label: 'Numéro de sécurité sociale', type: 'text' },
      { id: 'emploi', label: 'Emploi', type: 'text' },
      { id: 'niveau_hierarchique', label: 'Niveau hiérarchique', type: 'text' },
      {
        id: 'convention_collective_applicable',
        label: 'Convention collective applicable',
        type: 'text',
      },
      { id: 'date_entree_entreprise', label: "Date d'entrée dans l'entreprise", type: 'date' },
    ],
    placeholder: [
      { id: 'civilite', value: 'M.' },
      { id: 'prenom', value: '' },
      { id: 'nom', value: '' },
      { id: 'adresse', value: '' },
      { id: 'date_naissance', value: '' },
      { id: 'lieu_naissance', value: '' },
      { id: 'numero_securite_sociale', value: '' },
      { id: 'emploi', value: '' },
      { id: 'niveau_hierarchique', value: '' },
      { id: 'convention_collective_applicable', value: '' },
      { id: 'date_entree_entreprise', value: '' },
    ],
  },

  employeur_pp: {
    name: 'Employeur PP',
    description:
      "Variable objet composée de 6 éléments : civilité / prénom / nom / adresse de l'entreprise / SIREN / SIRET",
    category: 'object',
    type: 'object',
    options: [
      { id: 'civilite', label: 'Civilité', type: 'choice' },
      { id: 'prenom', label: 'Prénom', type: 'text' },
      { id: 'nom', label: 'Nom', type: 'text' },
      { id: 'adresse_entreprise', label: "Adresse de l'entreprise", type: 'text' },
      { id: 'siren', label: 'SIREN', type: 'text' },
      { id: 'siret', label: 'SIRET', type: 'text' },
    ],
    placeholder: [
      { id: 'civilite', value: 'M.' },
      { id: 'prenom', value: '' },
      { id: 'nom', value: '' },
      { id: 'adresse_entreprise', value: '' },
      { id: 'siren', value: '' },
      { id: 'siret', value: '' },
    ],
  },

  employeur_pm: {
    name: 'Employeur PM',
    description:
      "Variable objet composée de 13 éléments : dénomination sociale / forme sociale / capital social / adresse du siège social / ville d'immatriculation / numéro de SIREN / Numéro de SIRET / Représentant légal / Fonctions du représentant légal / Code NAF / Code APE / Convention collective / Nombre d'établissements",
    category: 'object',
    type: 'object',
    options: [
      { id: 'denomination_sociale', label: 'Dénomination sociale', type: 'text' },
      { id: 'forme_sociale', label: 'Forme sociale', type: 'text' },
      { id: 'capital_social', label: 'Capital social', type: 'number' },
      { id: 'adresse_siege_social', label: 'Adresse du siège social', type: 'text' },
      { id: 'ville_immatriculation', label: "Ville d'immatriculation", type: 'text' },
      { id: 'numero_siren', label: 'Numéro de SIREN', type: 'text' },
      { id: 'numero_siret', label: 'Numéro de SIRET', type: 'text' },
      { id: 'representant_legal', label: 'Représentant légal', type: 'text' },
      {
        id: 'fonctions_representant_legal',
        label: 'Fonctions du représentant légal',
        type: 'text',
      },
      { id: 'code_naf', label: 'Code NAF', type: 'text' },
      { id: 'code_ape', label: 'Code APE', type: 'text' },
      { id: 'convention_collective', label: 'Convention collective', type: 'text' },
      { id: 'nombre_etablissements', label: "Nombre d'établissements", type: 'number' },
    ],
    placeholder: [
      { id: 'denomination_sociale', value: '' },
      { id: 'forme_sociale', value: '' },
      { id: 'capital_social', value: 0 },
      { id: 'adresse_siege_social', value: '' },
      { id: 'ville_immatriculation', value: '' },
      { id: 'numero_siren', value: '' },
      { id: 'numero_siret', value: '' },
      { id: 'representant_legal', value: '' },
      { id: 'fonctions_representant_legal', value: '' },
      { id: 'code_naf', value: '' },
      { id: 'code_ape', value: '' },
      { id: 'convention_collective', value: '' },
      { id: 'nombre_etablissements', value: 0 },
    ],
  },

  etablissement: {
    name: 'Établissement',
    description:
      "Variable objet composée de 8 éléments : catégorie d'établissement / adresse de l'établissement / chef d'établissement / SIRET / convention collective applicable / Code NAF / effectif de l'établissement / présence de CSE",
    category: 'object',
    type: 'object',
    options: [
      { id: 'categorie_etablissement', label: "Catégorie d'établissement", type: 'text' },
      { id: 'adresse_etablissement', label: "Adresse de l'établissement", type: 'text' },
      { id: 'chef_etablissement', label: "Chef d'établissement", type: 'text' },
      { id: 'siret', label: 'SIRET', type: 'text' },
      {
        id: 'convention_collective_applicable',
        label: 'Convention collective applicable',
        type: 'text',
      },
      { id: 'code_naf', label: 'Code NAF', type: 'text' },
      { id: 'effectif_etablissement', label: "Effectif de l'établissement", type: 'number' },
      { id: 'presence_cse', label: 'Présence de CSE', type: 'bool' },
    ],
    placeholder: [
      { id: 'categorie_etablissement', value: '' },
      { id: 'adresse_etablissement', value: '' },
      { id: 'chef_etablissement', value: '' },
      { id: 'siret', value: '' },
      { id: 'convention_collective_applicable', value: '' },
      { id: 'code_naf', value: '' },
      { id: 'effectif_etablissement', value: 0 },
      { id: 'presence_cse', value: false },
    ],
  },

  representant_cse: {
    name: 'Représentant CSE',
    description: 'Variable objet composée de 3 éléments : civilité / prénom / nom',
    category: 'object',
    type: 'object',
    options: [
      { id: 'civilite', label: 'Civilité', type: 'choice' },
      { id: 'prenom', label: 'Prénom', type: 'text' },
      { id: 'nom', label: 'Nom', type: 'text' },
    ],
    placeholder: [
      { id: 'civilite', value: 'M.' },
      { id: 'prenom', value: '' },
      { id: 'nom', value: '' },
    ],
  },

  // ========================
  // VARIABLES TABLEAU
  // ========================

  personne_physique_simple_array: {
    name: 'Personne physique simple',
    description: 'Variable tableau composée de 4 éléments : civilité / prénom / nom / adresse',
    category: 'array',
    type: 'array',
    options: [
      { id: 'civilite', label: 'Civilité', type: 'choice' },
      { id: 'prenom', label: 'Prénom', type: 'text' },
      { id: 'nom', label: 'Nom', type: 'text' },
      { id: 'adresse', label: 'Adresse', type: 'text' },
    ],
    placeholder: [
      [
        { id: 'civilite', value: 'M.' },
        { id: 'prenom', value: '' },
        { id: 'nom', value: '' },
        { id: 'adresse', value: '' },
      ],
    ],
  },

  personne_physique_complet_array: {
    name: 'Personne physique complet',
    description:
      'Variable tableau composée de 6 éléments : civilité / prénom / nom / adresse / date de naissance / lieu de naissance',
    category: 'array',
    type: 'array',
    options: [
      { id: 'civilite', label: 'Civilité', type: 'choice' },
      { id: 'prenom', label: 'Prénom', type: 'text' },
      { id: 'nom', label: 'Nom', type: 'text' },
      { id: 'adresse', label: 'Adresse', type: 'text' },
      { id: 'date_naissance', label: 'Date de naissance', type: 'date' },
      { id: 'lieu_naissance', label: 'Lieu de naissance', type: 'text' },
    ],
    placeholder: [
      [
        { id: 'civilite', value: 'M.' },
        { id: 'prenom', value: '' },
        { id: 'nom', value: '' },
        { id: 'adresse', value: '' },
        { id: 'date_naissance', value: '' },
        { id: 'lieu_naissance', value: '' },
      ],
    ],
  },

  personne_morale_complet_array: {
    name: 'Personne morale complet',
    description:
      "Variable tableau composée de 8 éléments : dénomination sociale / forme sociale / capital social / adresse du siège social / ville d'immatriculation / numéro de SIREN / identité du représentant légal / fonctions du représentant légal",
    category: 'array',
    type: 'array',
    options: [
      { id: 'denomination_sociale', label: 'Dénomination sociale', type: 'text' },
      { id: 'forme_sociale', label: 'Forme sociale', type: 'text' },
      { id: 'capital_social', label: 'Capital social', type: 'number' },
      { id: 'adresse_siege_social', label: 'Adresse du siège social', type: 'text' },
      { id: 'ville_immatriculation', label: "Ville d'immatriculation", type: 'text' },
      { id: 'numero_siren', label: 'Numéro de SIREN', type: 'text' },
      { id: 'identite_representant_legal', label: 'Identité du représentant légal', type: 'text' },
      {
        id: 'fonctions_representant_legal',
        label: 'Fonctions du représentant légal',
        type: 'text',
      },
    ],
    placeholder: [
      [
        { id: 'denomination_sociale', value: '' },
        { id: 'forme_sociale', value: '' },
        { id: 'capital_social', value: 0 },
        { id: 'adresse_siege_social', value: '' },
        { id: 'ville_immatriculation', value: '' },
        { id: 'numero_siren', value: '' },
        { id: 'identite_representant_legal', value: '' },
        { id: 'fonctions_representant_legal', value: '' },
      ],
    ],
  },

  personne_morale_simple_array: {
    name: 'Personne morale simple',
    description:
      "Variable tableau composée de 7 éléments : dénomination sociale / forme sociale / capital social / adresse du siège social / ville d'immatriculation / numéro de SIREN / représentant légal / fonctions du représentant légal",
    category: 'array',
    type: 'array',
    options: [
      { id: 'denomination_sociale', label: 'Dénomination sociale', type: 'text' },
      { id: 'forme_sociale', label: 'Forme sociale', type: 'text' },
      { id: 'capital_social', label: 'Capital social', type: 'number' },
      { id: 'adresse_siege_social', label: 'Adresse du siège social', type: 'text' },
      { id: 'ville_immatriculation', label: "Ville d'immatriculation", type: 'text' },
      { id: 'numero_siren', label: 'Numéro de SIREN', type: 'text' },
      { id: 'representant_legal', label: 'Représentant légal', type: 'text' },
      {
        id: 'fonctions_representant_legal',
        label: 'Fonctions du représentant légal',
        type: 'text',
      },
    ],
    placeholder: [
      [
        { id: 'denomination_sociale', value: '' },
        { id: 'forme_sociale', value: '' },
        { id: 'capital_social', value: 0 },
        { id: 'adresse_siege_social', value: '' },
        { id: 'ville_immatriculation', value: '' },
        { id: 'numero_siren', value: '' },
        { id: 'representant_legal', value: '' },
        { id: 'fonctions_representant_legal', value: '' },
      ],
    ],
  },

  associe_pp_parts_array: {
    name: 'Associé PP - parts',
    description:
      'Variable tableau composée de 4 éléments : Civilité / Prénom / Nom / Nombre de parts',
    category: 'array',
    type: 'array',
    options: [
      { id: 'civilite', label: 'Civilité', type: 'choice' },
      { id: 'prenom', label: 'Prénom', type: 'text' },
      { id: 'nom', label: 'Nom', type: 'text' },
      { id: 'nombre_parts', label: 'Nombre de parts', type: 'number' },
    ],
    placeholder: [
      [
        { id: 'civilite', value: 'M.' },
        { id: 'prenom', value: '' },
        { id: 'nom', value: '' },
        { id: 'nombre_parts', value: 0 },
      ],
    ],
  },

  associe_pp_actions_array: {
    name: 'Associé PP - actions',
    description:
      "Variable tableau composée de 4 éléments : Civilité / Prénom / Nom / Nombre d'actions",
    category: 'array',
    type: 'array',
    options: [
      { id: 'civilite', label: 'Civilité', type: 'choice' },
      { id: 'prenom', label: 'Prénom', type: 'text' },
      { id: 'nom', label: 'Nom', type: 'text' },
      { id: 'nombre_actions', label: "Nombre d'actions", type: 'number' },
    ],
    placeholder: [
      [
        { id: 'civilite', value: 'M.' },
        { id: 'prenom', value: '' },
        { id: 'nom', value: '' },
        { id: 'nombre_actions', value: 0 },
      ],
    ],
  },

  associe_pm_parts_array: {
    name: 'Associé PM - parts',
    description:
      "Variable tableau composée de 8 éléments : dénomination sociale / forme sociale / capital social / adresse du siège social / ville d'immatriculation / numéro de SIREN / identité du représentant légal / nombre de parts",
    category: 'array',
    type: 'array',
    options: [
      { id: 'denomination_sociale', label: 'Dénomination sociale', type: 'text' },
      { id: 'forme_sociale', label: 'Forme sociale', type: 'text' },
      { id: 'capital_social', label: 'Capital social', type: 'number' },
      { id: 'adresse_siege_social', label: 'Adresse du siège social', type: 'text' },
      { id: 'ville_immatriculation', label: "Ville d'immatriculation", type: 'text' },
      { id: 'numero_siren', label: 'Numéro de SIREN', type: 'text' },
      { id: 'identite_representant_legal', label: 'Identité du représentant légal', type: 'text' },
      { id: 'nombre_parts', label: 'Nombre de parts', type: 'number' },
    ],
    placeholder: [
      [
        { id: 'denomination_sociale', value: '' },
        { id: 'forme_sociale', value: '' },
        { id: 'capital_social', value: 0 },
        { id: 'adresse_siege_social', value: '' },
        { id: 'ville_immatriculation', value: '' },
        { id: 'numero_siren', value: '' },
        { id: 'identite_representant_legal', value: '' },
        { id: 'nombre_parts', value: 0 },
      ],
    ],
  },

  associe_pm_actions_array: {
    name: 'Associé PM - actions',
    description:
      "Variable tableau composée de 8 éléments : dénomination sociale / forme sociale / capital social / adresse du siège social / ville d'immatriculation / numéro de SIREN / identité du représentant légal / nombre d'actions",
    category: 'array',
    type: 'array',
    options: [
      { id: 'denomination_sociale', label: 'Dénomination sociale', type: 'text' },
      { id: 'forme_sociale', label: 'Forme sociale', type: 'text' },
      { id: 'capital_social', label: 'Capital social', type: 'number' },
      { id: 'adresse_siege_social', label: 'Adresse du siège social', type: 'text' },
      { id: 'ville_immatriculation', label: "Ville d'immatriculation", type: 'text' },
      { id: 'numero_siren', label: 'Numéro de SIREN', type: 'text' },
      { id: 'identite_representant_legal', label: 'Identité du représentant légal', type: 'text' },
      { id: 'nombre_actions', label: "Nombre d'actions", type: 'number' },
    ],
    placeholder: [
      [
        { id: 'denomination_sociale', value: '' },
        { id: 'forme_sociale', value: '' },
        { id: 'capital_social', value: 0 },
        { id: 'adresse_siege_social', value: '' },
        { id: 'ville_immatriculation', value: '' },
        { id: 'numero_siren', value: '' },
        { id: 'identite_representant_legal', value: '' },
        { id: 'nombre_actions', value: 0 },
      ],
    ],
  },

  // ========================
  // TABLEAUX MULTI-OBJETS
  // ========================

  associes_parts_sociales_multiarray: {
    name: 'Tableau multi-objet associé parts sociales',
    description:
      "Tableau multi-objets avec deux types d'associés : PP et PM pour les parts sociales",
    category: 'multiarray',
    type: 'multiarray',
    objects: [
      {
        name: 'Associé PP - parts',
        options: [
          { id: 'civilite', label: 'Civilité', type: 'choice' },
          { id: 'prenom', label: 'Prénom', type: 'text' },
          { id: 'nom', label: 'Nom', type: 'text' },
          { id: 'nombre_parts', label: 'Nombre de parts', type: 'number' },
        ],
        placeholder: [
          { id: 'civilite', value: 'M.' },
          { id: 'prenom', value: '' },
          { id: 'nom', value: '' },
          { id: 'nombre_parts', value: 0 },
        ],
      },
      {
        name: 'Associé PM - parts',
        options: [
          { id: 'denomination_sociale', label: 'Dénomination sociale', type: 'text' },
          { id: 'forme_sociale', label: 'Forme sociale', type: 'text' },
          { id: 'capital_social', label: 'Capital social', type: 'number' },
          { id: 'adresse_siege_social', label: 'Adresse du siège social', type: 'text' },
          { id: 'ville_immatriculation', label: "Ville d'immatriculation", type: 'text' },
          { id: 'numero_siren', label: 'Numéro de SIREN', type: 'text' },
          {
            id: 'identite_representant_legal',
            label: 'Identité du représentant légal',
            type: 'text',
          },
          { id: 'nombre_parts', label: 'Nombre de parts', type: 'number' },
        ],
        placeholder: [
          { id: 'denomination_sociale', value: '' },
          { id: 'forme_sociale', value: '' },
          { id: 'capital_social', value: 0 },
          { id: 'adresse_siege_social', value: '' },
          { id: 'ville_immatriculation', value: '' },
          { id: 'numero_siren', value: '' },
          { id: 'identite_representant_legal', value: '' },
          { id: 'nombre_parts', value: 0 },
        ],
      },
    ],
  },

  associes_actions_multiarray: {
    name: 'Tableau multi-objet associé actions',
    description: "Tableau multi-objets avec deux types d'associés : PP et PM pour les actions",
    category: 'multiarray',
    type: 'multiarray',
    objects: [
      {
        name: 'Associé PP - actions',
        options: [
          { id: 'civilite', label: 'Civilité', type: 'choice' },
          { id: 'prenom', label: 'Prénom', type: 'text' },
          { id: 'nom', label: 'Nom', type: 'text' },
          { id: 'nombre_actions', label: "Nombre d'actions", type: 'number' },
        ],
        placeholder: [
          { id: 'civilite', value: 'M.' },
          { id: 'prenom', value: '' },
          { id: 'nom', value: '' },
          { id: 'nombre_actions', value: 0 },
        ],
      },
      {
        name: 'Associé PM - actions',
        options: [
          { id: 'denomination_sociale', label: 'Dénomination sociale', type: 'text' },
          { id: 'forme_sociale', label: 'Forme sociale', type: 'text' },
          { id: 'capital_social', label: 'Capital social', type: 'number' },
          { id: 'adresse_siege_social', label: 'Adresse du siège social', type: 'text' },
          { id: 'ville_immatriculation', label: "Ville d'immatriculation", type: 'text' },
          { id: 'numero_siren', label: 'Numéro de SIREN', type: 'text' },
          {
            id: 'identite_representant_legal',
            label: 'Identité du représentant légal',
            type: 'text',
          },
          { id: 'nombre_actions', label: "Nombre d'actions", type: 'number' },
        ],
        placeholder: [
          { id: 'denomination_sociale', value: '' },
          { id: 'forme_sociale', value: '' },
          { id: 'capital_social', value: 0 },
          { id: 'adresse_siege_social', value: '' },
          { id: 'ville_immatriculation', value: '' },
          { id: 'numero_siren', value: '' },
          { id: 'identite_representant_legal', value: '' },
          { id: 'nombre_actions', value: 0 },
        ],
      },
    ],
  },
};

// Fonction utilitaire pour obtenir un template par son ID
export const getVariableTemplate = (templateId) => {
  return VARIABLE_TEMPLATES[templateId] || null;
};

// Fonction utilitaire pour obtenir la liste des templates disponibles
export const getAvailableTemplates = () => {
  return Object.keys(VARIABLE_TEMPLATES).map((key) => ({
    id: key,
    name: VARIABLE_TEMPLATES[key].name,
    description: VARIABLE_TEMPLATES[key].description,
    category: VARIABLE_TEMPLATES[key].category,
    type: VARIABLE_TEMPLATES[key].type,
  }));
};

// Fonction utilitaire pour obtenir les templates par catégorie
export const getTemplatesByCategory = () => {
  const templates = getAvailableTemplates();
  return templates.reduce((acc, template) => {
    if (!acc[template.category]) {
      acc[template.category] = [];
    }
    acc[template.category].push(template);
    return acc;
  }, {});
};

// Fonction pour appliquer un template à une variable
export const applyTemplateToVariable = (templateId, variableName, variableQuestion) => {
  const template = getVariableTemplate(templateId);
  if (!template) return null;

  // Fonction pour traiter les options et ajouter les choix prédéfinis
  const processOptions = (options) => {
    return options
      ? options.map((option) => {
        const processed = { ...option };
        if (option.type === 'choice') {
          processed.showChoice = true;
          processed.showAddChoice = true;
          processed.showAddMulti = false;

          // Ajouter des options prédéfinies selon le champ
          if (option.id === 'civilite') {
            processed.options = ['Monsieur', 'Madame'];
          }
        }

        return processed;
      })
      : [];
  };

  let result = {
    name: variableName,
    question: variableQuestion,
    type: template.type,
    description: `Template: ${template.description}`,
    is_global: false,
    dependant_variable: 0, // 0 au lieu de null
    dependant_value: 0,
    dependant_variable_2: 0,
    dependant_value_2: 0,
    dependant_variable_3: 0,
    dependant_value_3: 0,
    composite_link: '',
    database_object_model_fields_mapping: [
      {
        database_object_model_name: '',
        mappingType: 'simple',
        data: [],
      },
    ],
  };

  // Traitement spécifique selon le type de template
  if (template.type === 'multiarray') {
    // Pour les tableaux multi-objets, la structure est différente
    // options est un tableau de tableaux où chaque sous-tableau représente un objet type
    result.options = template.objects.map((obj) => [
      // Premier élément avec le nom de l'objet
      {
        id: '__object_name__',
        label: obj.name,
        type: 'text',
      },
      // Puis les options de l'objet
      ...processOptions(obj.options),
    ]);

    // placeholder suit la même structure
    result.placeholder = template.objects.map((obj) => [
      // Premier élément avec le nom de l'objet
      {
        id: '__object_name__',
        value: obj.name,
      },
      // Puis les placeholders de l'objet
      ...(obj.placeholder ? obj.placeholder.map((p) => ({ ...p })) : []),
    ]);

    // Mapping pour multiarray
    result.database_object_model_fields_mapping = template.objects.map((obj, index) => ({
      database_object_model_name: '',
      mappingType: 'simple',
      label: obj.name,
      data: obj.options
        ? obj.options.map((option) => ({
            mapping_complex: '',
            database_object_model_field_name: '',
            variable_field_name: option.label,
          }))
        : [],
    }));
  } else {
    // Pour les objets et tableaux simples
    result.options = processOptions(template.options);

    if (template.type === 'array') {
      // Pour les tableaux, placeholder est un tableau de tableaux
      result.placeholder = template.placeholder
        ? template.placeholder.map((row) =>
            Array.isArray(row) ? row.map((p) => ({ ...p })) : [{ ...row }],
          )
        : [[]];
    } else {
      // Pour les objets simples
      result.placeholder = template.placeholder ? template.placeholder.map((p) => ({ ...p })) : [];
    }

    // Génération du mapping pour la BDD
    if (template.options) {
      result.database_object_model_fields_mapping[0].data = template.options.map((option) => ({
        mapping_complex: '',
        database_object_model_field_name: '',
        variable_field_name: option.label,
      }));
    }
  }

  return result;
};
